type Comparator<T> = (a: T, b: T) => number

function getComparator<T>(sortColumn: keyof T): Comparator<T> {
    switch (sortColumn) {
        case 'holidayDate':
            return (a: T, b: T) => {
                const dateA = new Date(a[sortColumn] as string)
                const dateB = new Date(b[sortColumn] as string)
                return dateA.getTime() - dateB.getTime()
            }
        case 'title':
        case 'name':
        case 'description':
            return (a: T, b: T) =>
                (a[sortColumn] as string).localeCompare(b[sortColumn] as string)
        default:
            throw new Error(`unsupported sortColumn: "${String(sortColumn)}"`)
    }
}
function truncateString(str: string) {
    const maxLength = 30
    return str?.length > maxLength ? str.substring(0, maxLength) + '...' : str
}
const MAX_CHAR_COUNT = 250

export { getComparator, truncateString, MAX_CHAR_COUNT }
